import { render } from "./polls.vue?vue&type=template&id=11067c4d"
import script from "./polls.vue?vue&type=script&lang=js"
export * from "./polls.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__